export default __webpack_public_path__ + "static/media/tag_restaurant.426f69b9.svg";